import useRegularOnly from '@discover-data/stores/hooks/regularOnly/useRegularOnly';
import { cn } from '@discover-lib/utils';
import Button, { type ButtonProps } from '@discover-ui/button';

export type AllButtonProps = Omit<ButtonProps, 'onClick'>;

type ExitRegularOnlyButtonProps = AllButtonProps & {
  content?: string;
};

export default function ExitRegularOnlyButton({
  content = 'See all restaurants',
  kind = 'outline',
  className,
  ...props
}: ExitRegularOnlyButtonProps) {
  const [, setRegularOnly] = useRegularOnly();
  return (
    <Button
      onClick={() => {
        setRegularOnly(null);
      }}
      kind={kind}
      className={cn('rounded-none', className)}
      {...props}>
      {content}
    </Button>
  );
}
